    <template>
        <form @submit.prevent="submit" class="register-form">
            <div v-if="errors !== null" class="notification is-danger">
                <template v-if="errors.length">
                    <div v-for="(error, index) in errors" :key="index">
                        {{error.description}}
                    </div>
                </template>
                <div v-if="errors.error">
                    {{errors.error}}
                </div>
                <span class="delete"></span>
            </div>
            <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                    <b-input v-model.trim="firstName" size="is-medium" type="text" name="firstName" required />
                </div>
            </div>
            <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                    <b-input v-model.trim="lastName" size="is-medium" type="text" name="lastName" required />
                </div>
            </div>
            <div class="field">
                <label class="label">Email</label>
                <div class="control">
                    <b-input v-model.trim="email" size="is-medium" type="email" name="email" required></b-input>
                </div>
            </div>
            <div class="field">
                <label class="label">Password</label>
                <div class="control">
                    <b-input v-model.trim="password" size="is-medium" type="password" name="password" required password-reveal></b-input>
                </div>
            </div>
            <div class="field two-rem">
                <div class="control">
                    <button :disabled="loading" class="button is-primary is-large is-fullwidth">Register</button>
                </div>
            </div>
        </form>
    </template>

    <script>
    export default {
        name: "RegisterForm",
        data() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            errors: null
        };
        },

        computed: {
        loading() {
            return this.$store.state.account.loading;
        }
        },
        methods: {
        submit() {
            const payload = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                password: this.password
            };
            this.$store
            .dispatch("account/register", payload)
            .then(() => {
                this.errors = null;
                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.password = "";
                this.$emit("success");
                this.$router.push('/comps')
            })
            .catch(error => {
                if (typeof error.data.error === "string" || error.data.error instanceof String) {
                this.errors = { error: error.data.error };
                } else {
                this.errors = error.data;
                }
            });
        }
        }
    };
    </script>

    <style>
    .register-form { margin: 2rem 0 ;}
    </style>
